import {
  Button,
  Card,
  Typography,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { TelenganaNorthenApiService } from "../httpsservice/ApiService";
import "../styles/index.css";

const BillCard = ({ billData }) => {
  const [payableAmount, setPayableAmount] = useState("");
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [isPayloading, setPayLoader] = useState(false);
  const [messageApi, contextHolder] = message.useMessage({
    duration: 0, // Keep message until manually closed
  });

  useEffect(()=>{
    const handleBFCache = (event) => {
      if (event.persisted){
        window.location.reload();
      }
    }
    window.addEventListener("pageshow", handleBFCache);
    return () => window.removeEventListener("pageshow", handleBFCache)
  }, [])

  useEffect(() => {
    if (billData) {
      if (billData.billTotalAmount > 0) {
        setPayableAmount(`${billData.billTotalAmount}`);
      } else {
        setPayableAmount("");
      }
    }
  }, [billData]);

  const handleAmountChange = (e) => {
    let amount = e.target.value
      .replace(/[^\d.]/g, "") // Remove all non-digit, non-dot
      .replace(/\.{2,}/g, ".") // Replace multiple dots with one
      .replace(/^(\d*\.\d*).*$/, "$1"); // Allow only the first decimal

    setPayableAmount(amount);
  };

  const handleAdvanceAmountChange = (e) => {
    let amount = e.target.value
      .replace(/[^\d.]/g, "") // Remove all non-digit, non-dot
      .replace(/\.{2,}/g, ".") // Replace multiple dots with one
      .replace(/^(\d*\.\d*).*$/, "$1"); // Allow only the first decimal

    setAdvanceAmount(amount);
  };

  const handlePayment = () => {
    messageApi.destroy(); // Clear existing messages first
    
    if (billData.isAdvance) {
      messageApi.info("This bill is already paid. You're all set!");
      return;
    }
    
    const amountToValidate = billData.isAdvance ? advanceAmount : payableAmount;
    const amount = Number(amountToValidate);
    
    if (!amountToValidate || amountToValidate.trim() === "" || isNaN(amount)) {
      messageApi.error("Please enter a valid amount!");
    } 
    else if (amount < 1) {
      messageApi.error("Amount should not be less than ₹1");
    }
    else if (
      billData.billTotalAmount > 0 &&
      !billData.isAdvance &&
      amount < billData.billTotalAmount
    ) {
      messageApi.error(
        `Amount should be equals to ${billData.billTotalAmount} INR`
      );
    }
    else {
      pay();
    }
  };

  const pay = async () => {
    setPayLoader(true);
    const queryData = {
      txnId: billData?.txnId,
      billId: billData?.billId,
      billTotalAmount: billData.isAdvance ? advanceAmount : payableAmount,
    };
    const response = await TelenganaNorthenApiService.payBill(queryData);
    if (response.success) {
      window.location.href = response.redirect_url;
    } else {
      messageApi.destroy(); // Clear existing messages first
      messageApi.error(
        response?.message || response?.data?.message ||
          `Failed to submit bill payment. Please try again after sometime.`
      );
    }
    setPayLoader(false);
  };

  const handelBackPress = () => {
    messageApi.destroy(); // Remove all messages
    window.location.href = "/TGNPDCL/Billpay";
    setPayableAmount("");
  };

  return (
    <>
      {contextHolder}
      <div className="tgnpdcl-bill-page-container">
        <div className="tgnpdcl-bill-page-content-wrapper">
          {/* Header */}
          <div className="tgnpdcl-bill-page-header">
            <div className="tgnpdcl-header-content">
              <img
                alt="TGNPDCL"
                className="tgnpdcl-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tel-north-main-logo.svg"
              />
              <span className="tgnpdcl-company-title">
                NORTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
              </span>
            </div>
            <h2 className="tgnpdcl-page-title">Bill Details</h2>
          </div>

          {/* Main Content */}
          <div className="tgnpdcl-bill-page-content">
            <div className="tgnpdcl-bill-details-section">
              {/* Bill Details Card */}
              <Card className="tgnpdcl-bill-details-card">
                <div className="tgnpdcl-bill-details-grid">
                  <div className="tgnpdcl-detail-row">
                    <span className="tgnpdcl-detail-label">Service Number :</span>
                    <span className="tgnpdcl-detail-value">{billData?.uscno || "N/A"}</span>
                  </div>
                  <div className="tgnpdcl-detail-row">
                    <span className="tgnpdcl-detail-label">Consumer Name :</span>
                    <span className="tgnpdcl-detail-value">{billData?.name || "N/A"}</span>
                  </div>
                  <div className="tgnpdcl-detail-row">
                    <span className="tgnpdcl-detail-label">Circle Code:</span>
                    <span className="tgnpdcl-detail-value">{billData?.circleCode || "N/A"}</span>
                  </div>
                  <div className="tgnpdcl-detail-row">
                    <span className="tgnpdcl-detail-label">ERO Name :</span>
                    <span className="tgnpdcl-detail-value">{billData?.eroName || "N/A"}</span>
                  </div>
                  {!billData.isAdvance && (
                    <>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">Bill Date :</span>
                        <span className="tgnpdcl-detail-value">{billData?.billDate || "N/A"}</span>
                      </div>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">Due Date:</span>
                        <span className="tgnpdcl-detail-value">{billData?.billDueDate || "N/A"}</span>
                      </div>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">Disconnection Date :</span>
                        <span className="tgnpdcl-detail-value">{billData?.billDisconnectionDate || "N/A"}</span>
                      </div>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">Current Month Demand :</span>
                        <span className="tgnpdcl-detail-value">{billData?.currentMonthDemand || "N/A"}</span>
                      </div>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">Arrear Amount :</span>
                        <span className="tgnpdcl-detail-value">₹ {billData?.arrearAmount ? parseFloat(billData.arrearAmount).toFixed(2) : "0.00"}</span>
                      </div>
                      <div className="tgnpdcl-detail-row">
                        <span className="tgnpdcl-detail-label">ACD Amount Due :</span>
                        <span className="tgnpdcl-detail-value">₹ {billData?.acdAmountDue ? parseFloat(billData.acdAmountDue).toFixed(2) : "0.00"}</span>
                      </div>
                    </>
                  )}
                  <div className="tgnpdcl-detail-row">
                    <span className="tgnpdcl-detail-label">Total Amount Due :</span>
                    <span className="tgnpdcl-detail-value">₹ {billData?.billTotalAmount ? parseFloat(billData.billTotalAmount).toFixed(2) : "0.00"}</span>
                  </div>
                </div>
              </Card>

              {/* Payment Buttons */}
              <div className="tgnpdcl-payment-buttons">
                <Button
                  className="tgnpdcl-submit-payment-btn"
                  size="large"
                  block
                  onClick={handlePayment}
                  loading={isPayloading}
                >
                  Submit Payment
                </Button>
                <Button
                  className="tgnpdcl-back-btn"
                  size="large"
                  block
                  type="link"
                  onClick={handelBackPress}
                >
                  Back
                </Button>
              </div>
            </div>

            {/* Transaction Service Charges */}
            <div className="tgnpdcl-charges-section">
              <Card className="tgnpdcl-charges-card">
                <h3 className="tgnpdcl-charges-title">Transaction Service Charges</h3>
                <div className="tgnpdcl-charges-list">
                  <div className="tgnpdcl-charge-row">
                    <span>Net Banking</span>
                    <span>₹ 2.50/- Per Transaction</span>
                  </div>
                  <div className="tgnpdcl-charge-row">
                    <span>RuPay Debit Cards & UPI</span>
                    <span>Nil</span>
                  </div>
                  <div className="tgnpdcl-charge-row">
                    <span>Credit Cards</span>
                    <span>0.75% of the Transaction Amount.</span>
                  </div>
                  <div className="tgnpdcl-charge-row">
                    <span>Debit Cards Up to 2000</span>
                    <span>0.4% of the Transaction amount.</span>
                  </div>
                  <div className="tgnpdcl-charge-row">
                    <span>Debit Cards above 2000</span>
                    <span>0.9% of the Transaction amount.</span>
                  </div>
                </div>
                <div className="tgnpdcl-charges-note">
                  <strong>Note:</strong> GST/Taxes applicable will be charged extra on the transaction fees.
                </div>
              </Card>
              
              {/* Advance Payment Alert */}
              {(billData.billTotalAmount <= 0 || billData.isAdvance) && (
                <div className="tgnpdcl-advance-payment-alert">
                  No bills pending for the service number.
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="tgnpdcl-bill-page-footer">
          <img
            alt="Powered By Easebuzz"
            className="tgnpdcl-powered-by-logo"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
          />
        </div>
      </div>
    </>
  );
};

export default BillCard;